export default function Spinner() {
  return (
    <div className="spinner-overlay">
      <div className="spinner" />
    </div>
  )
}